export enum SECTION_WIDTH {
  FULL_WIDTH = 'FULL_WIDTH',
  HALF_WIDTH = 'HALF_WIDTH',
  ONE_THIRD_WIDTH = 'ONE_THIRD_WIDTH',
}

export enum VIEW_BUILDER_TYPES {
  INPUT = 'INPUT',
  OUTPUT = 'OUTPUT',
  BOTH = 'BOTH',
}
export enum FORM_BUILDER_ELEMENT_TYPES {
  SECTION_TITLE = 'SECTION_TITLE',
  SHORT_ANSWER = 'SHORT_ANSWER',
  PARAGRAPH = 'PARAGRAPH',
  CHECKBOX = 'CHECKBOX',
  RADIO_BUTTON = 'RADIO_BUTTON',
  UPLOAD_FIELD = 'UPLOAD_FIELD',
  DROPDOWN = 'DROPDOWN',
  DATE_TIME = 'DATE_TIME',
  NAME = 'NAME',
  ADDRESS = 'ADDRESS',
  NUMBER = 'NUMBER',
  EMAIL = 'EMAIL',
  CONTACT_NUMBER = 'CONTACT_NUMBER',
  DOCUMENT_REQUEST = 'DOCUMENT_REQUEST',
  SECURITY_OPTIONS = 'SECURITY_OPTIONS',
  DATE = 'DATE',
  TIME = 'TIME',
}
